import { withTranslation, useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useMemo } from "react";
import { Grid, Skeleton, useMediaQuery } from "@mui/material";
import clsx from "clsx";
import styles from "./Search.module.scss";
import LocationSpecialities from "../../../Home/LocationSpecialities";
import { getRandomBackgroundImage } from "../background";
import "./override.scss";
import SavedSearchHome from "../../../SavedSearches/SavedSearchHome";

interface SearchProps {
  completedSteps: {
    [key: string]: boolean;
  };
  useProfileIframe: boolean;
  firstName?: string;
}

const Search = ({
  completedSteps,
  useProfileIframe,
  firstName
}: SearchProps) => {
  const { t } = useTranslation();

  const isCompact = useMediaQuery("(max-width: 768px)");

  const isLoading = firstName == null;

  const requiredStepsCount = useProfileIframe ? 4 : 5;
  const completedStepsCount = completedSteps != null ? Object.keys(completedSteps).length : 0;
  const isProfileComplete = completedStepsCount >= requiredStepsCount;
  const randomBackgroundImage = useMemo(() => getRandomBackgroundImage(), []);

  const searchBar = isLoading ? (
    <div className={styles.skeleton}>
      {!isCompact && (
        <Skeleton />
      )}

      {isCompact && (
        <>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        </>
      )}
    </div>
  ) : (
    <LocationSpecialities
      hideHeading
      enableDashboardAd={false}
      translate={t}
      componentName={t("globalSearch.location.componentDashboard")}
    />
  );


  const savedSearchHome = isLoading ? (
    <div>
      <div className={styles.skeletonSaveSearchTxt}>
        <Skeleton />
      </div>
      <Grid container className={styles.skeletonSaveSearchChip}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Grid>
    </div>
  ) : (
    <SavedSearchHome isProfileComplete={isProfileComplete} />
  );

  if (isProfileComplete === false) {
    return (
      <div className={styles.main}>
        <div className={styles.sub}>
          <div className={styles.nextDestinationHeading}>
            {t("dashboard.searchBar.nextDestinationHeading")}
          </div>

          <div>
            {searchBar}
          </div>
          
          <div>
            {savedSearchHome}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={clsx(styles.main, styles.completeProfile)} style={{
      backgroundImage: `linear-gradient(0deg, rgba(0, 51, 102, 0.60) 0%, rgba(0, 51, 102, 0.60) 100%), url("${randomBackgroundImage}")`,
    }}>
      <div className={styles.sub}>
       <div className={styles.completeProfileSub}>
        <div id="job-search-heading" data-testid="welcomeText" className={styles.welcomeHeading}>
          {t("dashboard.banner.dashProfileBannerTxt1")}{" "}
          {firstName}{"! "}
          {t("dashboard.banner.myProfileNavCompleteTxt2")}
        </div>
        <div id="job-search-heading" className={styles.exploreSubHeading}>
          {t("dashboard.banner.dashProfileBannerTxt4")} {" "}
          {t("dashboard.banner.dashProfileBannerTxt5")} {" "}
          {t("dashboard.banner.dashProfileBannerTxt6")}
        </div>

        <div>
          {searchBar}
        </div>
       </div>
        <div>
          {savedSearchHome}
        </div>
      </div>
    </div>
  );
}

Search.defaultProps = {
  firstName: null
}

const mapStateToProps = (state) => ({
  completedSteps: state.onBoarding.completedSteps,
  useProfileIframe: state.auth.useProfileIframe,
  firstName: state.auth.firstName
});

export default connect(mapStateToProps)(withTranslation()(Search));